import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EqualizerIconComponent} from './equalizer-icon/equalizer-icon.component';
import {IconNavComponent} from './icon-nav/icon-nav.component';
import {PlanningSeparatorComponent} from './planning-separator/planning-separator.component';
import {SmartCoverComponent} from './smart-cover/smart-cover.component';
import {WaveComponent} from './wave/wave.component';
import {PipesModule} from '../../pipes/pipes.module';
import {SharedModule} from '../../shared.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';


@NgModule({
  declarations: [
    EqualizerIconComponent,
    IconNavComponent,
    PlanningSeparatorComponent,
    SmartCoverComponent,
    WaveComponent
  ],
    exports: [
        SmartCoverComponent,
        IconNavComponent,
        EqualizerIconComponent,
    ],
  imports: [
    CommonModule,
    PipesModule,
    SharedModule,
    MatProgressSpinnerModule
  ]
})
export class ImagesModule { }
